import { TEmailReportSmallPreview } from "./types"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { ResourcePreview } from "../../../../components/Resources/preview"
import { Box } from "@mui/material"

export function EmailReportSmallPreview({ email }: TEmailReportSmallPreview) {
    const { t } = useTranslation()

    const [emailRender, setEmailRender] = useState<string | undefined>()
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(fetchEmailRender, [email])

    function fetchEmailRender() {
        if (email) {
            setLoading(true)
            email.render().then((content) => {
                setEmailRender(content)
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    return <Box className="emailReportSmallPreview"><ResourcePreview loading={loading} content={emailRender} thumbnail_url={email?.thumbnail_url} /></Box>
}
